import Api from '../http.service';

// sign out jwt

export const signOut = () => Api.GET({ url: 'jwt/signout' });
export const currentUser = () => Api.GET({ url: 'jwt/current_user' });
export const verify = () => Api.HEAD({ url: 'jwt/verify' });
